import classNames from 'classnames';
import { Select } from 'components/2-molecules/Inputs';
import { useEffect, useState } from 'react';
import styles from './NewsLetterSignUpTextBox.module.scss';

export type NewsLetterSignUpSelectProps = {
	required: boolean;
	idName: string;
	lblName: string;
	submitTried: boolean;
	options: { name: string; idValue: string; idName: string }[];
	onChange?: (formElement: HTMLFormElement) => void;
};

export const NewsLetterSignUpSelect: React.FC<NewsLetterSignUpSelectProps> = ({ required, idName, lblName, submitTried, onChange, options }) => {
	const [value, setValue] = useState<string>('');
	const [errors, setErrors] = useState(undefined);

	useEffect(() => {
		if (required && value.trim().length === 0 && submitTried) {
			setErrors(['Felt skal udfyldes']);
		} else {
			setErrors(undefined);
		}
	}, [submitTried, value, required]);

	const handleChange = (e) => {
		setValue(e.target.value);
		onChange && onChange(e.target.form);
	};

	return (
		<div className={classNames(styles.NewsLetterTextBox)} key={idName}>
			<label className="" htmlFor={idName}>
				{lblName}:
			</label>
			<div className="">
				<Select name={idName} id={idName} required={required} value={value} onChange={(e) => handleChange(e)} errors={errors}>
					{options.map((option, index) => {
						return (
							<option value={option.idValue} key={index}>
								{option.idValue}
							</option>
						);
					})}
				</Select>
			</div>
		</div>
	);
};
